import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useGetChatInfo = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
    chatService: true,
  });

  const getChatInfo = (chatId: string) => {
    send({}, `/api/v1/conversation/${chatId}`).then();
  };

  return {
    getChatInfo,
    data,
    isLoading,
    error,
  };
};
